import { render, staticRenderFns } from "./create-product-field.vue?vue&type=template&id=a18924ea&scoped=true&"
import script from "./create-product-field.vue?vue&type=script&lang=js&"
export * from "./create-product-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18924ea",
  null
  
)

export default component.exports